import React, { ReactNode, useEffect, useRef, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router';

import styles from './styles.module.css';
import SolarisLogoGreen from '@/assets/SolarisLogoGreen.svg?react';

type HeaderLink = {
  URL: string;
  component: ReactNode;
  icon?: ReactNode;
};

type HeaderProps = {
  links?: HeaderLink[];
  icons?: ReactNode[];
  showLineSelector?: boolean;
};

export default function Header({
  links = [],
  icons = [],
  showLineSelector = false
}: HeaderProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [underlineStyle, setUnderlineStyle] = useState({});
  const location = useLocation();

  useEffect(() => {
    if (!containerRef.current) return;
    if (!showLineSelector) return;

    const updateUnderline = () => {
      const active = containerRef.current!.querySelector(
        `.${styles.activeLink}`
      );
      if (active) {
        const { offsetLeft, offsetWidth } = active as HTMLElement;
        setUnderlineStyle({
          transform: `translateX(${offsetLeft}px)`,
          width: `${offsetWidth}px`
        });
      }
    };

    updateUnderline();

    window.addEventListener('resize', updateUnderline);
    return () => window.removeEventListener('resize', updateUnderline);
  }, [location.pathname, links.length]);

  return (
    <div className={styles.stickyHeader}>
      <div className={styles.headerContainer}>
        <Link to="/">
          <SolarisLogoGreen className={styles.solarisLogo} />
        </Link>
        <div className={styles.headerBodyContainer}>
          <Link to="/">
            <h1 className={styles.pulseTitle}>Pulse</h1>
          </Link>

          {links.length > 0 ? (
            <div
              ref={containerRef}
              className={styles.linksContainer}
              style={{ '--tab-count': links.length } as React.CSSProperties}
            >
              {links.map(link => (
                <NavLink key={link.URL} to={link.URL}>
                  {({ isActive }) => (
                    <div
                      className={`${styles.link} ${isActive && styles.activeLink} ${links.length === 1 && styles.linksMarginRight}`}
                    >
                      <div className={styles.linkContent}>
                        {link.icon}
                        {link.component}
                      </div>
                    </div>
                  )}
                </NavLink>
              ))}

              {showLineSelector && (
                <div className={styles.underline} style={underlineStyle} />
              )}
            </div>
          ) : null}

          {icons.length > 0 ? (
            <div className={styles.iconsContainer}>
              {icons.map(icon => icon)}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
